import React, { useState, useEffect } from "react";
import styles from "./CSS/PromptModal.module.css";
import { calculateTextNumber, calculateTextNumberByte } from "../util/etCetera";
import { useTranslation } from "react-i18next";

const PromptModal = ({
  isOpen,
  onClose,
  initialState,
  handleSubmit,
  textCount = false,
  closeOnOutsideClick = true,
  // 선택: 글자수 제한 표시/placeholder 지원
  placeholder,
  flexibleDataForTextLimit,
  fieldNameForTextLimit,
  readOnly = false,
}) => {
  const [inputObject, setInputObject] = useState({});
  const [keyName, setKeyName] = useState("");
  const [title, setTitle] = useState("");
  const { t } = useTranslation();
  useEffect(() => {
    if (isOpen) {
      setInputObject(initialState);
      setKeyName(initialState.keyName || "comment");
      setTitle(initialState.title || t("common.labels.content"));
    }
  }, [isOpen, initialState, t]);

  if (!isOpen) return null;

  const handleOutsideClick = (e) => {
    if (
      closeOnOutsideClick &&
      e.target.className.includes(styles.modalOverlay)
    ) {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOutsideClick}>
      <div className={styles.modalContainer}>
        <div
          className="p-2 d-flex justify-content-between"
          style={{ fontSize: "16px" }}
        >
          <div>
            {title}{" "}
            <span style={{ color: "#0d6efd" }}>
              {initialState?.fullname ? "(" + initialState?.fullname + ")" : ""}
            </span>
          </div>
          {textCount
            ? (() => {
                const textValue = inputObject[keyName] || "";
                const info = calculateTextNumber(
                  textValue,
                  flexibleDataForTextLimit,
                  fieldNameForTextLimit,
                );
                const label =
                  (typeof info === "string" ? info : info.text) +
                  "/" +
                  calculateTextNumberByte(textValue);
                const styleObj =
                  typeof info === "string" || !info.color
                    ? {}
                    : { color: info.color, fontWeight: "bold" };
                return (
                  <span style={styleObj}>
                    {" "}
                    {t("common.labels.textLength")}: {label}
                  </span>
                );
              })()
            : ""}
        </div>
        <div className={styles.modalContent}>
          <textarea
            className="form-control"
            rows="7"
            value={inputObject[keyName] ? inputObject[keyName] : ""}
            onChange={(e) => {
              if (readOnly) return;
              setInputObject((prev) => ({
                ...prev,
                [keyName]: e.target.value,
              }));
            }}
            autoFocus
            placeholder={placeholder || ""}
            readOnly={readOnly}
            style={readOnly ? { backgroundColor: "#e9ecef" } : undefined}
          />
          {!readOnly && (
            <button
              className="btn btn-sm btn-primary mt-1"
              onClick={() => {
                handleSubmit(inputObject);
                onClose();
              }}
            >
              입력
            </button>
          )}
          <button className="btn btn-sm btn-warning mt-1" onClick={onClose}>
            {t("common.labels.cancel") || "취소"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromptModal;
